export default {
   authors: [],
   isFetcheAuthors: false,
   isOpenAuthorPopup: false,
   isOpenDeleteAuthorPopup: false,
};
